// eslint-disable-next-line import-x/prefer-default-export
export const ALL_LIST = 'ALL_LIST';
